<template>
  <v-container fluid>
    <v-form :ref="'formArboTreeview_' + _uid">
      <v-select
        :rules="required && required != false ? getRules : []"
        @focus="reset"
        @click="getOpen"
        :ref="'SelectedTreeview' + _uid"
        v-click-outside="onClickOutside"
        :filled="getIrisRdonlyMode"
        :disabled="getIrisRdonlyMode"
        :menu-props="menuProps"
        v-model="fakeModel"
        :items="fakeItems"
        chips
        :label="label"
        item-text="name"
        item-value="name"
        multiple
      >
        <template v-slot:label>
          <div v-if="required && required != false && !getIrisRdonlyMode">
            {{ label }} <span class="red--text">*</span>
          </div>
        </template>
        <template v-slot:selection>
          <v-chip
            v-for="(itemID, index) in getItems"
            :key="'chip' + index"
            :small="getIrisMode"
            :text-color="getIrisChipTxtColor"
            :color="getIrisChipColor"
            class="ma-2"
          >
            {{ getSelectedValues(items, itemID).name }}
          </v-chip>
        </template>
        <template v-slot:prepend-item>
          <v-treeview
            open-on-click
            @update:active="setLabelNoData($event)"
            @input="setLabelNoData($event)"
            :activatable="!isMultiple"
            :selectable="isMultiple"
            :active.sync="active"
            v-model="activeItem"
            :selected-color="colors.primary"
            :selection-type="selectionType"
            :items="items"
            item-disabled="Disabled"
          >
            <template v-slot:prepend="{ item }">
              <v-icon v-if="item.icon">
                {{ item.icon }}
              </v-icon>
            </template>
          </v-treeview>
        </template>
        <template v-slot:append-outer v-if="tooltip">
          <edn-tooltip> {{ tooltip }}</edn-tooltip>
        </template>
        <template v-slot:append v-if="getIrisRdonlyMode">
          <v-icon class="v-icon--disabled">mdi-menu-down</v-icon>
          <v-icon class="v-icon--disabled">mdi-lock</v-icon>
        </template>
      </v-select>
    </v-form>
  </v-container>
</template>

<script>
import { ednRegex } from './mixins/ednRegex'
import { ednRequired } from './mixins/ednRequired'
import { ednMimicMix } from './mixins/ednMimicMix'

import ednTooltip from './ednTooltip'
export default {
  mixins: [ednRegex, ednRequired, ednMimicMix],
  components: {
    ednTooltip,
  },
  props: {
    label: {
      type: String,
      default: '',
    },
    required: {
      type: [Boolean, String],
      default: false,
    },
    requiredMinLength: {
      type: Number,
      default: 0,
    },
    placeholder: {
      type: String,
      default: '',
    },
    tooltip: {
      type: String,
      default: '',
    },
    selection: {
      type: Array,
      default: () => [],
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    items: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      active: [], // Récupère les valeurs déjà sélectionnées
      activeItem: [], // Récupère les valeurs déjà sélectionnées
      colors: {
        //Définit les couleurs de vuetify
        primary: this.$vuetify.theme.currentTheme.primary,
        secondary: this.$vuetify.theme.currentTheme.secondary,
      },

      updateAfterClose: true, // Permet de savoir si la MAJ a été envoyer au composant parent
      selectionType: 'independent', // Le type de séléction, leaf ou independent (voir vuetify treeview)
      menuProps: {
        // Permet de mettre le menu sous le select
        offsetY: true,
      },
      // Un fake Model est nécessaire pour customiser le select avec un treeview
      fakeModel: ['Eudonet'],
      // Un fake Item est nécessaire pour customiser le select avec un treeview
      fakeItems: [
        {
          name: 'Eudonet',
          disabled: true,
        },
      ],
    }
  },
  methods: {
    // Permet de reset les rules au momement d'ouvrir le menu
    reset() {
      this.$refs['formArboTreeview_' + this._uid].resetValidation()
    },
    // Fonction qui permet au moment d'ouvir le menu de passer la data updateAfterClose à false
    getOpen() {
      // A chaque ouverture on dit au menu de ne pas se fermer si on click dedans
      this.menuProps = {
        closeOnContentClick: false,
        // Permet de mettre le menu sous le select
        offsetY: true,
      }

      this.updateAfterClose = false
    },
    // Fonction qui permet au moment de changer une valeur si il y a aucunes valeur selectionner alors on laisser la place au label
    // eventClick = Si on click sur une valeur selectionable seulement
    setLabelNoData(eventClick) {
      if (eventClick) {
        // Alors on ferme le menu dropdown (treeview)
        this.menuProps = {
          closeOnContentClick: !this.isMultiple, // En chois simple uniquement
          // Permet de mettre le menu sous le select
          offsetY: true,
        }
      }
      setTimeout(() => {
        if (this.isMultiple ? this.activeItem.length <= 0 : this.active.length <= 0) {
          if (!this.placeholder) {
            this.fakeModel = []
            this.fakeItems = []
          }
        } else {
          this.fakeModel = ['Eudonet']
          this.fakeItems = [
            {
              name: 'Eudonet',
              disabled: true,
            },
          ]
        }
      }, 0)
    },
    // Fonction qui permet au moment du clique en dehors du composant de lancer une fonction de callBack pour le composant parent
    // Et met a jour le fait que updateAfterClose est a true
    onClickOutside() {
      setTimeout(() => {
        if (!this.$refs['SelectedTreeview' + this._uid].isMenuActive && !this.updateAfterClose) {
          this.$emit('callback-selection', this.isMultiple ? this.activeItem : this.active)
          this.updateAfterClose = true
          if (this.placeholder) this.setPlaceholder()
        }
      }, 0)
    },

    /** Permet de trouver dans le tableau de donnée ($attrs.items), le nom des valeurs déja séléctionnés (this.$attrs.selection)
     * (varArr) Arr
     * (itemID) Num
     */
    getSelectedValues(varArr, itemID) {
      let arr = {}
      // Expected a `for-of` loop instead of a `for` loop with this simple iteration.
      for (let c of varArr) {
        if (c.children && c.children.length > 0) {
          let w = this.getSelectedValues(c.children, itemID)
          if (w.id == itemID) {
            arr = w
          }
        }
        if (c.id == itemID) {
          arr = c
        }
      }
      return arr
    },
    // Return le message d'erreur de la rules
    getMsg() {
      return this.required && this.required != true ? this.required : this.invalidMsg
    },
    // Return le nombre de tag minimum pour activé la rules
    getNumMinRequired() {
      return this.requiredMinLength
    },
    // Return le placeholder
    setPlaceholder() {
      setTimeout(() => {
        if (this.isMultiple ? this.activeItem.length <= 0 : this.active <= 0) {
          this.$refs['SelectedTreeview' + this._uid].$el.classList.remove('v-input--is-dirty')
          this.$refs['SelectedTreeview' + this._uid].$refs.input.setAttribute('placeholder', this.placeholder)
        }
      }, 0)
    },
  },
  mounted() {
    // Si les donnée selectionnées sont vide
    if (this.isMultiple ? this.activeItem.length <= 0 : this.active <= 0) {
      if (!this.placeholder) {
        this.fakeModel = []
        this.fakeItems = []
      } else {
        this.setPlaceholder()
      }
    } else {
      this.fakeModel = ['Eudonet']
      this.fakeItems = [
        {
          name: 'Eudonet',
          disabled: true,
        },
      ]
    }
  },
  computed: {
    // Return la rules
    getRules() {
      if (this.isMultiple) {
        return [this.activeItem.length > this.getNumMinRequired() || this.getMsg()]
      } else {
        return [this.active.length >= this.getNumMinRequired() || this.getMsg()]
      }
    },
    // Return les couleurs des chips en fonction du mode dans le quel on est, irisMimic
    getIrisChipColor() {
      // Extract this nested ternary operation into an independent statement
      if (this.getIrisRdonlyMode) return 'grey lighten-2'

      if (this.getIrisMode) return 'grey lighten-1'

      return ''
    },
    // Return la couleur du text des chips en fonction du mode dans le quel on est, irisMimic
    getIrisChipTxtColor() {
      // Extract this nested ternary operation into an independent statement
      if (this.getIrisRdonlyMode) return 'grey darken-2'

      if (this.getIrisMode) return 'grey darken-3'

      return ''
    },
    /** Renvoie la/les valeurs sélectionnée(s) */
    getItems() {
      return this.isMultiple ? this.activeItem : this.active
    },
  },
  watch: {
    active(val) {
      if (!this.multiple) this.$emit('update:selection', val)
    },
    activeItem(val) {
      this.$emit('update:selection', val)
    },
  },
  created() {
    this.active = !this.multiple ? this.selection : []
    this.activeItem = this.selection
  },
}
</script>

<style>
.v-treeview + .v-list-item {
  display: none;
}

.v-treeview .v-treeview-node {
  cursor: pointer;
}

.v-treeview-node--click.v-treeview-node--disabled > .v-treeview-node__root,
.v-treeview-node--click.v-treeview-node--disabled > .v-treeview-node__root > .v-treeview-node__content > * {
  cursor: auto;
}
</style>
